var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rorschach",class:_vm.rorschachClasses},[_c('div',{staticClass:"wrapper",class:_vm.pausedClasses,style:({
      'background-image': ("url(" + _vm.poster + ")")
    })},[_c('video',{ref:"video",staticClass:"video",attrs:{"muted":"","autoplay":"","playsinline":"","src":_vm.src,"poster":"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"},domProps:{"muted":true},on:{"playing":function($event){_vm.paused = false}}})]),_vm._v(" "),(_vm.hasDefaultSlot)?_c('p',{staticClass:"p",class:{
      'text-center': _vm.center
    }},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efe78ed6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/person/Rorschach.vue
// module id = null
// module chunks = 